/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import { useSelector } from 'react-redux';
import { RootState } from '../../app/store';
import { downloadFile, FILENAME } from './ExportService';
import { getMediaResistancesPdf, PDF_CONTENT_TYPE } from '../../api/MediaResistanceAPI';
import { buildMediaResistanceQuery } from '../../features/media-resistance/MediaResistance';
import { econdaClickEvent, econdaDownloadEvent } from '../../Econda';
import { LoadingSpinner } from 'festo-react-ui-kit';

interface exportPDFProps {
  language: string;
  isDisabled: boolean;
  isDownloadPDF: boolean;
  setIsDownloadPDF: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function ExportPDF({ language, isDisabled, isDownloadPDF, setIsDownloadPDF }: exportPDFProps): JSX.Element {
  const PDF_FILE_EXTENSION = '.pdf';

  const t = useTranslation();
  const mediaResistances = useSelector((state: RootState) => state.mediaResistances);
  const materialCategories = useSelector((state: RootState) => state.materialCategories);
  const medias = useSelector((state: RootState) => state.medias);
  const materials = useSelector((state: RootState) => state.materials);
  const resistanceTypes = useSelector((state: RootState) => state.resistanceTypes);

  useEffect(() => {
    if (isDownloadPDF && mediaResistances.totalElements !== 0) {
      generateAndDownloadPdf();
    }
  }, [mediaResistances.completeValues]);

  async function generateAndDownloadPdf() {
    const query = buildMediaResistanceQuery(
      {
        language: language,
        mediaIds: medias.selectedIds,
        materialIds: materials.selectedIds,
        materialCategoryIds: materialCategories.selectedIds,
      },
      resistanceTypes.selected,
    );
    await getMediaResistancesPdf(query)
      .then((response) => {
        downloadFile(response.data, PDF_CONTENT_TYPE, t(FILENAME) + PDF_FILE_EXTENSION);
      })
      .finally(() => setIsDownloadPDF(false));
  }

  const disableClassname = (isDownloadPDF || isDisabled) && 'download--disable'

  return (
      <a
        href="#download-pdf"
        onClick={(e) => {
          if (isDownloadPDF || isDisabled) { e.preventDefault(); return; }
          setIsDownloadPDF(true);
          generateAndDownloadPdf();
          econdaDownloadEvent('download', 'product information pdf', 'blind menu', 'download pdf - ' + t(FILENAME));
          econdaClickEvent('download buttons', 'general', 'blind menu', t('pdfText'));
        }}
        className={`one-line pointer ${disableClassname ?? ""}`}
      >
        <div className="fwe-icon fwe-icon-documents-doc-pdf marging-right-link marging-right-link"></div>
        <div className="hide-text font-size--normal pr--medium linked-text-marging-right">{t('pdfText')}</div>
        {isDownloadPDF && <LoadingSpinner text={t('downloading')} />}
      </a>
  );
}
